import styled from 'styled-components';
import Gender from '../../../components/fields/GenderField';
import { type Brightness } from '../../context';
import { PorscheSelectCss } from './shared';
import withPorscheSelect from './withPorscheSelect';

const PorscheGenderField = styled(Gender)<Brightness>`
    ${PorscheSelectCss}
`;

const GenderField = withPorscheSelect(PorscheGenderField);
export default GenderField;
